module.exports = __webpack_public_path__ + "static/media/live-chat.7cb5535b.svg";